export enum CommunicationTaskType {
    createdReport = 'createdReport',
    signedReportBySpecialist = 'signedReportBySpecialist',
    signedReportByResponsible = 'signedReportByResponsible',
    finishedReport = 'finishedReport'
}
